<template>
    <div class="onlineRoom">
        <div class="list" v-if="commpanyAreas.length>0">
            <a class="item" v-for="(item,index) in commpanyAreas" :href="item.link" :key="index">
                <img :src="item.banner" alt="">
                <div class="name">
                    <p>{{item.name}}</p>
                    <span><van-icon name="arrow" /></span>
                </div>
            </a>
        </div>
        <div class="footerHeight">
		</div>
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from "@/components/Footer.vue"
import {MeetingCompanyAreas,MeetingsDetails} from  "../../config/interface.js";
export default {
    components:{
        Footer
    },
    data(){
        return{
            meeting_id:'',
            commpanyAreas:[]
        }
    },
	beforeRouteEnter(to, from, next) {
        //  修复iOS版微信HTML5 History兼容性问题
        if (to.path !== location.pathname) {
            // 此处不可使用location.replace
            location.assign(to.fullPath)
        } else {
                next()
        }
    },
    mounted(){
        this.meeting_id=this.$route.query.id;
        this.getAreasList();
        this.getMeetingDetails();
    },
    methods:{
        getAreasList(){
            const url=MeetingCompanyAreas;
            const methods='POST';
            let params={
                meeting_id:this.meeting_id
            }
            fetch(url,params,methods)
            .then((res)=>{
                if(res.code==0){
                    var data=res.data;
                    this.commpanyAreas=data;
                }
            })
        },
			//会议详情
		getMeetingDetails(){
				const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						document.title=data.name;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(data.name,'线上展厅',data.shareimg);
                        }
						
						
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
    }
}
</script>
<style lang="scss" scoped>
    .onlineRoom{
        position: relative;
    }
    .list{
        
        padding:22px 12px;
        @include flex(row);
        flex-wrap:wrap;
        justify-content: space-between;
        .item{
            overflow: hidden;
            width:170px;
            background:rgba(255,255,255,1);
            border-radius:8px;
            border:1px solid #901D22;
            margin-bottom:12px;
            img{
                width:100%;
            }
            .name{
                padding:5px;
                @include flex(row);
                justify-content: space-between;
                color:#1a1a1a;
                p{
                    flex:1;
                    text-align:justify;
                }
                span{
                    display:flex;  
                    margin-left:5px;
                    justify-content: center;
                    align-items: center;
                    width:16px;
                    height:16px;
                    border-radius: 100%;
                    align-items: center;
                    background:#901D22;
                    i{
                        color:#fff;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/meeting/onlineShowRoom.vue